import type { DepositAccount } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

const useGetInternalDepositAccounts = requestBuilder.query<DepositAccount[]>({
    endpoint: () =>
        '/api/depository-transfer/list-accounts?type=ACTIVE_DEPOSITORY_INTERNAL',
    queryKey: () =>
        'depository-transfer/list-accounts/ACTIVE_DEPOSITORY_INTERNAL',
});

export default useGetInternalDepositAccounts;
